import React, { useState } from "react";
import { Button, Divider, Grid, Typography } from "@mui/material";
import CustomTextField from "src/components/forms/theme-elements/CustomTextField";
import CustomFormLabel from "src/components/forms/theme-elements/CustomFormLabel";
import ParentCard from "src/components/shared/ParentCard";
import Breadcrumb from "src/layouts/full/shared/breadcrumb/Breadcrumb";
import { useFormik } from "formik";
import * as yup from "yup";
import { useNavigate } from "react-router";
import swal from "sweetalert";
import { IconArrowBack } from "@tabler/icons";
import PreviewImage from "src/components/previewImage/PreviewImage";
import LogoService from "src/service/logoService";

const BCrumb = [
  {
    to: "/",
    title: "Home",
  },
  {
    title: "Add Logo",
  },
];

const validationSchema = yup.object({
  header_name: yup
    .string("Enter Header Name")
    .matches(/^[a-zA-Z ]+$/, "Header Name should only contain Alphabet")
    .min(2, "Header Name should be of minimum 2 characters in length")
    .max(30, "Header Name should be of maximum 30 characters in length")
    .required("Header Name is required"),

  logo: yup.string("upload logo").required("Logo is required"),
});

const AddDynamicLogo = () => {
  const sessionData = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();

  const [previewImage, setPreviewImage] = useState(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      setPreviewImage(file);
    }
  };

  const initialValues = {
    header_name: "",
    logo: "",
    c_by: sessionData.data.id,
  };

  const { values, errors, touched, handleChange, handleBlur, handleSubmit } =
    useFormik({
      initialValues: initialValues,
      validationSchema: validationSchema,
      onSubmit: async (values) => {
        // alert(JSON.stringify(values, null, 2));

        try {
          const formData = new FormData();
          formData.append("header_name", values.header_name);
          formData.append("logo", previewImage);
          formData.append("c_by", sessionData.data.id);
          const res = await LogoService.addLogo(formData);
          swal("success", res.message, "success");
          setTimeout(() => {
            navigate("/dynamiclogolist");
          }, 1000);
        } catch (error) {
          swal("error", error, "error");
        }
      },
    });

  return (
    <div>
      <Breadcrumb title="Add Logo" items={BCrumb} />
      <ParentCard title="Add Logo">
        <Grid container alignItems="center">
          <Grid
            item
            xs={4}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Typography
              style={{
                fontSize: "22px",
                fontWeight: "bold",
                fontFamily: "Sans-Serif",
              }}
              variant="h2"
            >
              Add Logo
            </Typography>
          </Grid>

          <Grid
            item
            xs={8}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                navigate("/dynamiclogolist");
              }}
            >
              <IconArrowBack width={20} />
            </Button>
          </Grid>
        </Grid>
        <Divider />
        <form onSubmit={handleSubmit}>
          <Grid container spacing={3} style={{ marginTop: "5px" }}>
            <Grid
              item
              lg={6}
              md={6}
              sm={6}
              xs={12}
              style={{ marginTop: "-10px" }}
            >
              <CustomFormLabel htmlFor="header_name">
                Header Name <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomTextField
                id="header_name"
                name="header_name"
                type="text"
                value={values.header_name}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.header_name && Boolean(errors.header_name)}
                helperText={touched.header_name && errors.header_name}
                variant="outlined"
                placeholder="Enter header name"
                fullWidth
              />
            </Grid>

            <Grid item lg={6} md={6} sm={6} xs={12} sx={{ marginTop: "-5px" }}>
              <CustomFormLabel htmlFor="logo">
                Upload Logo <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomTextField
                accept="image/*"
                id="logo"
                name="logo"
                type="file"
                // onChange={handleFileChange}
                onChange={(event) => {
                  handleChange(event);
                  handleFileChange(event);
                }}
                onBlur={handleBlur}
                error={touched.logo && Boolean(errors.logo)}
                helperText={touched.logo && errors.logo}
                style={{ width: "100%" }}
              />
            </Grid>

            {/* ===== textarea */}

            <Grid item lg={6} md={6} sm={6} xs={12} sx={{ marginTop: "-5px" }}>
              {previewImage && <PreviewImage file={previewImage} />}
            </Grid>
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              style={{ marginTop: "10px" }}
            >
              <Button color="primary" variant="contained" type="submit">
                Submit
              </Button>
            </Grid>
          </Grid>
        </form>
      </ParentCard>
    </div>
  );
};

export default AddDynamicLogo;
